import React from 'react';
import { Button } from '../../../../../patterns/00-atoms/button/button.tsx';
import { Paths } from '../../../../../utils/paths.ts';
import { RestaurantDetails_getRestaurantDetails } from '../../../../../types/graphql-types-generated.ts';
import { prgLink } from '../../../../../utils/prg-resolver.ts';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type FeedbackPlateProps = {
  restaurantDetails: RestaurantDetails_getRestaurantDetails;
};

export const FeedbackPlate: React.FunctionComponent<FeedbackPlateProps> = props => {
  return (
    <div className="text-sk-dark-blue bg-white p-8 text-center md:rounded-b-3xl">
      {/* TODO: gradient in icon */}
      <i className="ic-like-filled text-sk-red-900 mb-4 block text-6xl" />
      <p className="mb-4 text-2xl font-extrabold">Vielen Dank, dass Du speisekarte.de nutzt!</p>
      <p className="mb-4 text-sm">
        Wir wünschen Dir viel Spaß bei Deinem nächsten Restaurant Besuch.
      </p>
      <p className="mb-4 text-sm">
        Du hast Verbesserungsvorschläge oder hast fehlerhafte Informationen gefunden? Wir freuen uns
        über Dein Feedback!
      </p>
      <Button
        onClick={() => {
          UBTracking.state.restaurant = props.restaurantDetails;
          UBTracking.trackEvent.click('closing_element', 'FEEDBACK_BUTTON');
          prgLink(
            Paths.restaurantFeedback(
              props.restaurantDetails.linkedCity.fullnameLower,
              props.restaurantDetails.keyname
            )
          );
        }}
      >
        Feedback geben
      </Button>
    </div>
  );
};
